/**
 * Prefer server `message` over machine `error` (e.g. PLAN_LIMIT_REACHED) so UI matches the API interceptor.
 */
export function getMutationErrorMessage(err: unknown, fallback: string): string {
  const anyErr = err as { data?: unknown; message?: string } | undefined;
  const data = anyErr?.data;

  if (typeof data === 'string' && data.trim()) {
    return data;
  }

  if (data && typeof data === 'object' && !Array.isArray(data)) {
    const o = data as { message?: unknown; error?: unknown };
    if (typeof o.message === 'string' && o.message.trim()) {
      return o.message;
    }
    if (typeof o.error === 'string' && o.error.trim()) {
      return o.error;
    }
  }

  if (typeof anyErr?.message === 'string' && anyErr.message.trim()) {
    return anyErr.message;
  }

  return fallback;
}
